import { createUseStyles } from "react-jss";

const modes = {
  backgroundColor: "#334e70",
  primaryColor: "#E6DCD2",
  primaryColorHover: "#dbccbd",
  primaryColorPressed: "#905a27",

  alertColor: "#d61a3c",

  white: "#ffffff",
  // headingColor: "#37332f",
  // textColor: "#58524b",
  headingColor: "#2c2627",
  textColor: "#584b4e",

  borderLightColor: "#d0ccc8",

  accentColor: "#fbf5ef",
  accentColorDarker: "#f7ebde",
};

const properties = {
  gap: "120px",
  mobileBreakPoint: "800px",
  layout: {
    width: "1240px",
    padding: "40px",
    mobilePadding: "24px",
  },
  logoInlineSize: "460px",
};

const LayoutGird = {
  paddingInline: properties.layout.padding,
  maxInlineSize: properties.layout.width,
  margin: "auto",

  [`@media (max-width: ${properties.mobileBreakPoint})`]: {
    paddingInline: properties.layout.mobilePadding,
  },
};

export const footer = createUseStyles({
  wrapper: {
    backgroundColor: "rgba(230, 220, 210, 0.48)",
    marginTop: "120px",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      marginTop: "64px",
    },
  },

  container: {
    blockSize: "64px",
    display: "flex",
    alignItems: "center",
    marginBlockStart: "120px",
    paddingInline: "48px",
    gap: "16px",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      flexDirection: "column",
      blockSize: "100%",
      paddingBlock: "24px",
      gap: "4px",

      "& span:first-of-type": {
        color: modes.headingColor,
        paddingBlockEnd: "12px",
      },
    },
  },
});

export const header = createUseStyles({
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    inlineSize: "100%",
    boxShadow: "0px 8px 32px -1px rgba(0,0,0,0.08)",
    zIndex: 3,
    backgroundColor: modes.white,
  },
  content: {
    display: "flex",
    alignItems: "center",
    inlineSize: "100%",
    justifyContent: "space-between",
    blockSize: "80px",
    ...LayoutGird,
  },
  logoContainer: {},

  logoLink: {
    fontFamily: "Playfair Display !important",
    textDecoration: "none",
    fontSize: "28px",
    fontWeight: "400",
    display: "flex",
    gap: "8px",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",

    "& img": {
      inlineSize: "auto",
      maxBlockSize: "60px",
    },

    "&:visited": {
      color: "inherit",
    },
    "&.active": {
      cursor: "default",
    },
  },

  nav: {
    display: "flex",
    alignItems: "center",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      display: "none",
    },

    "& ~ div": {
      display: "none",

      [`@media (max-width: ${properties.mobileBreakPoint})`]: {
        display: "block",
      },
    },
  },
  navList: {
    display: "flex",
    gap: "8px",
    justifyContent: "center",
    alignItems: "center",
  },
  navListItem: {},

  navListItemLink: {
    textDecoration: "none",
    color: modes.headingColor,
    fontSize: "18px",
    paddingBlock: "14px 16px",
    paddingInline: "16px",
    position: "relative",
    cursor: "pointer",

    "&:not(.active):hover": {
      backgroundColor: "rgba(230, 220, 210, 0.4)",
    },
    "&.active": {
      cursor: "default",

      "&:after": {
        inlineSize: "calc(100% - 32px)",
        borderBlockEnd: `2px solid ${modes.primaryColor}`,
        left: "50%",
        transform: "translateX(-50%)",
        bottom: "0px",
        content: '" "',
        position: "absolute",
        zIndex: "2",
      },
    },
  },
});

// export const button = createUseStyles({

export const grid = createUseStyles({
  base: {
    minInlineSize: "100vw",
    minBlockSize: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    maxInlineSize: properties.layout.width,
    overflow: "hidden",
  },

  positioner: {
    maxInlineSize: properties.layout.width,
    inlineSize: "100%",
    boxSizing: "border-box",
    margin: "auto",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      maxInlineSize: "100vw",
      paddingBlockStart: "108px",
    },
  },

  contentWrapper: {
    ...LayoutGird,
  },
});

export const cookie = createUseStyles({
  cookieBanner: {
    position: "fixed",
    bottom: "0",
    left: "0",
    paddingBlock: "24px",
    paddingInline: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    inlineSize: "100%",
    fontSize: "16px",
    backgroundColor: modes.accentColor,
    color: modes.headingColor,
    margin: "0",
    lineHeight: "1.4",
    zIndex: "2",
    gap: "24px",

    "& .cookie-icon-container": {
      display: "flex",
      gap: "8px",
      justifyContent: "center",
      alignItems: "center",

      [`@media (max-width: ${properties.mobileBreakPoint})`]: {
        "& .bi-cookie": {
          display: "none",
        },
      },

      "& .bi-cookie": {
        color: modes.primaryColorHover,
        fontSize: "24px",
        backgroundColor: modes.accentColorDarker,
        padding: "8px",
        inlineSize: "40px",
        blockSize: "40px",
        borderRadius: "100%",
      },
    },
  },
});

export const layout = createUseStyles({
  offerRow: {
    textAlign: "center",
    alignItems: "center",
    marginBlockStart: "16px",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      alignItems: "center",
      textAlign: "center",
    },

    " & h3": {
      textAlign: "left",

      [`@media (max-width: ${properties.mobileBreakPoint})`]: {
        paddingBlockEnd: "2px",
        textAlign: "center",
      },
    },
  },
  gridThreeColumns: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    marginBottom: "120px",
    gap: "24px",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      gridTemplateColumns: "1fr",
      marginBottom: "64px",
    },
  },
  gridTwoColumns: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    marginBottom: "120px",
    gap: "24px",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      gridTemplateColumns: "1fr",
      marginBottom: "64px",
    },
  },

  headerTopPadding: {
    paddingBlockStart: "140px",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      paddingBlockStart: "0px",
    },
  },
  gridFourColumns: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    marginBottom: "120px",
    gap: "24px",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      gridTemplateColumns: "1fr",
      marginBottom: "64px",
    },
  },

  flexColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    justifyContent: "center",
    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      "&.mobile-center": {
        textAlign: "center",
      },
    },

    "& .pakiet-card": {
      inlineSize: "100%",
      alignItems: "flex-start",
      justifyContent: "center",
      paddingBlockStart: "8px",

      [`@media (max-width: ${properties.mobileBreakPoint})`]: {
        alignItems: "center",
      },
    },
  },

  flexRow: {
    display: "flex",
    gap: "24px",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      flexDirection: "column",
      gap: "16px",
      alignItems: "center",
    },
  },

  flexMobileReverse: {
    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      display: "flex",
      flexDirection: "column-reverse !important",
    },
  },
});

export const heading = createUseStyles({
  quote: {
    maxInlineSize: "960px",
    fontSize: "44px",
    textAlign: "center",
    lineHeight: "1.3",
    fontStyle: "italic",
    fontWeight: "500",
    color: modes.headingColor,

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      fontSize: "20px",
    },
  },
  logo: {
    fontSize: "36px",
    lineHeight: "1.3",
    color: modes.headingColor,
    fontWeight: "700",
    marginBlockEnd: "6px",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      fontSize: "32px",
    },
  },
  l: {
    fontSize: "48px",
    lineHeight: "1.3",
    color: modes.headingColor,
    fontWeight: "700",
    marginBlockEnd: "-12px",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      fontSize: "40px",

      "&.mobile-s": {
        fontSize: "24px",
        paddingBlockEnd: "4px",
      },
    },
  },
  m: {
    fontSize: "32px",
    lineHeight: "1.3",
    color: modes.headingColor,
    fontWeight: "700",
    marginBlockEnd: "0px",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      fontSize: "28px",
    },
  },
  s: {
    fontSize: "24px",
    lineHeight: "1.3",
    color: modes.headingColor,
    fontWeight: "600",
    marginBlockEnd: "-2px",
  },
  cardBg: {
    position: "absolute",
    bottom: 0,
    left: 0,
    inlineSize: "100%",
    paddingBlock: "16px 24px",
    // paddingInline: "24px",
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "column",
    background:
      "linear-gradient(0deg, rgba(255, 255, 255, 0.8),  rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0))",
    backdropFilter: "blur(8px)",
    borderBlockStart: "1px solid rgba(255, 255, 255, 0.24)",
    transition: "all 0.3s ease-in",
    textAlign: "center",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      textAlign: "center",
      fontSize: "26px",
    },
  },

  cardLink: {
    "&:hover h3": {
      borderColor: modes.primaryColor,
      // background:
      //   "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0))",
      paddingBlock: " 72px 24px",
    },
  },
});

export const text = createUseStyles({
  l: {
    fontSize: "20px",
    lineHeight: "1.5",
    color: modes.textColor,

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      fontSize: "18px",
    },
  },
});

export const button = createUseStyles({
  l: {
    backgroundColor: modes.primaryColor,
    blockSize: "52px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingInline: "28px",
    fontWeight: "700",
    textTransform: "uppercase",
    fontSize: "18px",
    color: modes.headingColor,
    textDecoration: "none",
    cursor: "pointer",
    border: `1px solid ${modes.primaryColor}`,
    paddingBlock: "14px 16px",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      fontSize: "16px",
      blockSize: "48px",
      paddingInline: "24px",
    },

    "&:hover": {
      backgroundColor: modes.primaryColorHover,
    },

    "&.secondary": {
      backgroundColor: "transparent",
      color: modes.textColor,
      fontSize: "18px",

      "&:hover": {
        backgroundColor: "rgba(230, 220, 210, 0.48)",
        cursor: "pointer",
      },
    },
    "&.tertiary": {
      backgroundColor: "rgba(58, 24, 28, 0.12)",
      color: modes.textColor,
      fontSize: "18px",

      "&:hover": {
        backgroundColor: "rgba(58, 24, 28, 0.2)",
        cursor: "pointer",
      },
    },
  },

  header: {
    textDecoration: "none",
    color: modes.headingColor,
    fontSize: "18px",
    paddingBlock: "14px 16px",
    paddingInline: "16px",
    position: "relative",
    cursor: "pointer",
    fontWeight: "700",
    // textTransform: "uppercase",
    border: `1px solid ${modes.primaryColor}`,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: modes.primaryColor,
    display: "flex",

    "&:hover": {
      backgroundColor: modes.primaryColorHover,
    },
  },
});

export const spacing = createUseStyles({
  text: {
    paddingBlockStart: "16px",
  },
  section: {
    paddingBlockStart: "48px",
  },
  sectionBottom: {
    paddingBlockEnd: "48px",
  },
  sectionMarginBottom: {
    paddingBlockEnd: "120px",
  },
  marginBlockL: {
    marginBlock: "120px",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      marginBlock: "64px",
    },
  },
  paddingBlockM: {
    paddingBlock: "80px",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      paddingBlock: "56px",
    },
  },
});

export const hyperlink = createUseStyles({
  base: {
    color: modes.textColor,
    paddingInline: "12px",
    paddingBlock: "10px 12px",
    transition: " all 0.3s ease-in-out",
    // borderBlockEnd: `1px solid ${modes.textColor}`,
    display: "flex",
    alignItems: "center",
    gap: "8px",

    "&:hover": {
      backgroundColor: modes.primaryColor,
      cursor: "pointer",
    },
  },
  copy: {
    color: modes.textColor,
  },
});

export const contactCard = createUseStyles({
  base: {
    inlineSize: "100%",
    blockSize: "100%",
    maxBlockSize: "400px",
    minBlockSize: "400px",
    alignItems: "center",
    backgroundColor: "rgba(230, 220, 210, 0.48)",
    backdropFilter: "blur(48px)",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      maxBlockSize: "unset",
      minBlockSize: "unset",
      padding: "32px",
    },
  },
});

export const listOffer = createUseStyles({
  headingMobile: {
    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      textAlign: "center",
    },
  },
  listOffer: {
    paddingBlockStart: "4px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      gap: "16px",
    },

    "& li": {
      textAlign: "left",

      [`@media (max-width: ${properties.mobileBreakPoint})`]: {
        listStyle: "none !important",
        margin: "0 !important",
        textAlign: "center",
      },
    },
  },
});

export const hamburger = createUseStyles({
  wrapper: {},
  list: {
    display: "flex",
    alignItems: "center",
    marginBlockStart: "24px",
    gap: "40px !important",
  },

  listItem: {
    textDecoration: "none",
    color: modes.textColor,
    fontSize: "24px",
    paddingBottom: "4px",
    borderBlockEnd: `2px solid transparent`,

    "&.active": {
      borderBlockEnd: `4px solid ${modes.primaryColor}`,
    },
  },
});

export const gallery = createUseStyles({
  grid: {
    inlineSize: "100%",
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "8px",
    marginBlockStart: "16px",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
  },
  section: {
    display: "flex",
    flexDirection: "column",
    maxBlockSize: "100%",
    blockSize: "fit-content",
    minBlockSize: "100vh",
  },
  heading: {
    fontSize: "48px",
    fontWeight: "600",
    textAlign: "center",
    paddingBlock: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      fontSize: "32px !important",
    },
  },
  subHeading: {
    paddingBlockStart: "8px",
    fontSize: "28px",
    fontWeight: "400",
    letterSpacing: "1px",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      fontSize: "20px !important",
    },
  },

  imgWrapper: {
    display: "grid",
    inlineSize: "100%",
    marginBlockEnd: "40px",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "16px",
    blockSize: "max-content",
    maxBlockSize: "100%",

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
  },
  img: {
    inlineSize: "100%",
    blockSize: "100%",
    display: "flex",
    objectFit: "cover",

    "&:hover": {
      cursor: "pointer",
    },
  },

  lightbox: {
    position: "fixed",
    maxBlockSize: "100vh !important",

    "& img": {
      padding: "24px",
      maxBlockSize: "100vh !important",
    },

    "&:before": {
      inlineSize: "100%",
      blockSize: "100%",
      backgroundColor: "rgba(0,0,0,0.24)",
      position: "absolute",
      content: "' '",
    },
  },

  lightboxButton: {
    blockSize: "44px !important",
    inlineSize: "44px !important",
    minBlockSize: "44px !important",
    minInlineSize: "44px !important",
    display: "flex",
    marginInline: "80px !important",
    padding: "0 !important",
    backgroundColor: "rgba(0,0,0,0.16) !important",
    boxSizing: "border-box",
    zIndex: "10",
    border: "none",

    "&:hover": {
      cursor: "pointer",
    },

    "&.close": {
      position: "absolute",
      top: "24px",
      right: "24px",
      transform: "translateX(24px)",

      [`@media (max-width: ${properties.mobileBreakPoint})`]: {
        top: "24px",
      },
    },

    "&:disabled": {
      display: "none",
    },

    [`@media (max-width: ${properties.mobileBreakPoint})`]: {
      marginInline: "24px !important",
    },

    "&.active svg": {
      color: modes.primaryColor,
    },

    "& svg": {
      inlineSize: "44px",
      blockSize: "44px",
      color: "white",
      zIndex: "12",
      padding: "8px",
      boxSizing: "border-box",

      "&:hover": {
        color: modes.primaryColor,
      },
    },
  },
});
